import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  categoryName: string;
  imageUrl: string;
  author: string;
  date: string;
  views: number;
  tags: string[];
  variant?: 'default' | 'featured' | 'compact';
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  category,
  categoryName,
  imageUrl,
  author,
  date,
  views,
  tags,
  variant = 'default',
}: ArticleCardProps) {
  if (variant === 'featured') {
    return (
      <Link
        to={`/article/${slug}`}
        className="group block relative rounded-lg overflow-hidden h-[400px] md:h-[460px]"
      >
        <img
          src={imageUrl}
          alt={title}
          title={`${title} - 爆料网`}
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-black/10"></div>
        <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
          <span className="inline-block px-3 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full mb-3">
            {categoryName}
          </span>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-white mb-2 group-hover:text-primary-200 transition-colors">
            {title}
          </h2>
          <p className="text-sm text-white/80 line-clamp-2 mb-3">{excerpt}</p>
          <div className="flex items-center gap-3 text-xs text-white/60">
            <span className="flex items-center gap-1">
              <i className="ri-user-line"></i>
              {author}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line"></i>
              {date}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {views.toLocaleString()}
            </span>
          </div>
        </div>
      </Link>
    );
  }

  if (variant === 'compact') {
    return (
      <Link
        to={`/article/${slug}`}
        className="group flex gap-4 p-3 rounded-lg hover:bg-background-100 transition-colors"
      >
        <div className="w-20 h-20 flex-shrink-0 rounded-md overflow-hidden">
          <img
            src={imageUrl}
            alt={title}
            title={`${title} - 爆料网`}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
          />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-heading font-bold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2">
            {title}
          </h4>
          <div className="flex items-center gap-2 mt-1.5 text-xs text-foreground-500">
            <span>{date}</span>
            <span>·</span>
            <span>{views.toLocaleString()} 阅读</span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/article/${slug}`}
      className="group block rounded-lg overflow-hidden bg-background-50 hover:bg-background-100 transition-colors"
    >
      <div className="relative aspect-[16/10] overflow-hidden">
        <img
          src={imageUrl}
          alt={title}
          title={`${title} - 爆料网`}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute top-3 left-3">
          <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full">
            {categoryName}
          </span>
        </div>
      </div>
      <div className="p-4 md:p-5">
        <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
          {title}
        </h3>
        <p className="text-sm text-foreground-600 line-clamp-2 mb-3">{excerpt}</p>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-user-line"></i>
              {author}
            </span>
            <span>{date}</span>
          </div>
          <span className="text-xs text-foreground-400 flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {views.toLocaleString()}
          </span>
        </div>
      </div>
    </Link>
  );
}